import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { setEmbedScriptsEnabled } from '@realsite/blocks';
import { installStaleChunkRecovery } from './lib/staleChunk';
import './index.css';
import './styles/previewDarkSurface.css';

// Before anything renders: a tab opened before the last deploy will fail its first lazy import,
// and without this that is a blank page rather than a reload. See lib/staleChunk.ts.
installStaleChunkRecovery();

// A Raw HTML section's embed scripts run only on the live site, never here on breadlist.site
// (Dawn, 2026-10-20). Allowed iframes still show in the Studio; see packages/blocks RawHtml.
setEmbedScriptsEnabled(false);

// Which build is this tab ACTUALLY running? One console line + <html data-build>, so
// "is the deploy live?" is a glance (F12 → Console), never a day of guessing against a
// cached index.html. Check it with: document.documentElement.dataset.build
console.info(`[Bread List Sites] build ${__BUILD_INFO__}`);
document.documentElement.dataset.build = __BUILD_INFO__;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 401/403
        if (error instanceof Error && error.message.includes('401')) return false;
        if (error instanceof Error && error.message.includes('403')) return false;
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
